<!--<xng-breadcrumb></xng-breadcrumb>-->
<nav id="breadcrumb" class="flex-even" aria-label="breadcrumb">
  <ol class="breadcrumb">
    @if (breadcrumbBase$ | async; as breadcrumbs) {
      @for (breadcrumb of breadcrumbs; track breadcrumb.routeLink + breadcrumb.label ; let last = $last; let index = $index) {
        @if (!last) {
          <li class="breadcrumb-item" aria-current="page">
            <a routerLink="{{breadcrumb.routeLink}}">{{ breadcrumb.label }} </a>
          </li>
        }
        @if (last) {
          <li class="breadcrumb-item active" aria-current="page">
            {{ breadcrumb.label }}
          </li>
        }
      }
      @if (breadcrumbs?.length === 0) {
        <li></li>
      }
    }
  </ol>
</nav>
